import React from "react";
import ReactDOM from "react-dom/client";
import "../src/styles/Index/index.css";
import App from "./App";
import Home from "./Components/Home/Home";
import Entry from "./Components/Entry/Entry";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useState } from "react";

function AppState() {
  const [fieldState, setFieldState] = useState({
    "Graphic Design": false,
    "Web Development": true,
  });
  const handleFieldState = (key, value) => {
    setFieldState({ [key]: value });
    // console.log(`GD": ${fieldState["Graphic Design"]}`);
    // console.log(`WEB D: ${fieldState["Web Development"]}`);
  };

  const router = createBrowserRouter([
    // {
    //   path: "/",
    //   element: (
    //     <Entry
    //       fieldState={fieldState}
    //       handleFieldState={handleFieldState}
    //     />
    //   ),
    //   children: [{ index: true, element: <Entry /> }],
    // },
    {
      path: "/",
      element: (
        <Home
          fieldState={fieldState}
          handleFieldState={handleFieldState}
        />
      ),
      children: [{ index: true, element: <Home /> }],
    },
  ]);

  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppState />);
